var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.50033C15.8333 10.722 13.2217 13.3337 10 13.3337M15.8333 7.50033C15.8333 4.27866 13.2217 1.66699 10 1.66699M15.8333 7.50033H4.16667M10 13.3337C6.77834 13.3337 4.16667 10.722 4.16667 7.50033M10 13.3337C11.4591 11.7363 12.289 9.66331 12.3341 7.50033C12.289 5.33735 11.4591 3.26436 10 1.66699M10 13.3337C8.54092 11.7363 7.71249 9.66331 7.66743 7.50033C7.71249 5.33735 8.54092 3.26436 10 1.66699M10 13.3337V15.0003M4.16667 7.50033C4.16667 4.27866 6.77834 1.66699 10 1.66699M11.6667 16.667C11.6667 17.5875 10.9205 18.3337 10 18.3337C9.07953 18.3337 8.33333 17.5875 8.33333 16.667M11.6667 16.667C11.6667 15.7465 10.9205 15.0003 10 15.0003M11.6667 16.667H17.5M8.33333 16.667C8.33333 15.7465 9.07953 15.0003 10 15.0003M8.33333 16.667H2.5",
    stroke: "#38CB89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyField);
export default __webpack_public_path__ + "static/media/company-field.fd0f650f0d4772e94f86cd98d32ce5a5.svg";
export { ForwardRef as ReactComponent };